import { find } from 'lodash-es'
import { getParent, types } from 'mobx-state-tree'

import { Actors, TFreightie, TUser, TUsers } from '../Actors'

export const Subscription = types
  .model('Subscription', {
    freightieIds: types.optional(types.array(types.string), []),
    userIds: types.optional(types.array(types.string), []),
    modifiedAt: types.optional(types.string, ''),
  })
  .views((self) => ({
    get activityFeed() {
      return getParent(self)
    },
    getActors(ids, actors): TUser[] | TFreightie[] {
      return ids.reduce((acc, id) => {
        const actor = find(actors, (actor) => actor._id === id)
        if (actor) {
          acc.push(actor)
        }
        return acc
      }, [])
    },
  }))
  .views((self) => ({
    get subscribers(): ISubscribers {
      const {
        actors: { users, freighties },
      } = self.activityFeed
      const subsFreightieActors = self.getActors(self.freightieIds, freighties)
      const subsUserActors = self.getActors(self.userIds, users)
      return {
        freighties: subsFreightieActors,
        users: subsUserActors,
      } as ISubscribers
    },
    get isUserDisabled(): boolean {
      return self.userIds.length < 2
    },
  }))
  .views((self) => ({
    getUniqueUsers(users: TUsers): TUser[] {
      return users.users.filter((user) => !self.subscribers.users.some((subscriber) => subscriber._id === user._id))
    },
  }))
  .actions((self) => ({
    addSubscriber(id: string, idType: TIdType) {
      if (idType === USER_ID) {
        self.userIds.every((userId) => userId !== id) && self.userIds.push(id)
      } else {
        self.freightieIds.every((freightieId) => freightieId !== id) && self.freightieIds.push(id)
      }
    },
    removeSubscriber(id, idType: TIdType) {
      if (idType === USER_ID && !self.isUserDisabled) {
        self.userIds.remove(id)
      }
    },
  }))

export const SubscriptionModel = types.model('SubscriptionModel', {
  actors: Actors,
  subscription: types.maybe(Subscription),
})

export interface ISubscribers {
  freighties: TFreightie[]
  users: TUser[]
}
export const USER_ID = 'userId'
export const FREIGHTIE_ID = 'freightieId'
export type TSubscription = typeof Subscription.Type
export type TSubscriptionModel = typeof SubscriptionModel.Type
export type TIdType = typeof USER_ID | typeof FREIGHTIE_ID
